
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateTodoDtoFormGroup() {
return new FormGroup({
    title: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
    description: new FormControl<string | undefined>(''),
    assignedToUserId: new FormControl<number | undefined>(undefined),
    dueAt: new FormControl<string | undefined>(undefined),
    completedAt: new FormControl<string | undefined>(undefined),
    priority: new FormControl<string | undefined>(''),
    active: new FormControl<boolean | undefined>(undefined),
    status: new FormControl<string | undefined>(''),
})
;
}
      